import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {ConceptoService, PageBusquedaObject, Ctbcon} from '../concepto-service.service';
import { LoginService } from '../../../login/login.service';
import { NotificationService } from '../../../notifications/notification.service';

@Component({
  selector: 'app-catalogo-concepto',
  templateUrl: './catalogo-concepto.component.html',
  styleUrls: ['./catalogo-concepto.component.css'],
  providers: [NotificationService],
  preserveWhitespaces: true
})
export class CatalogoConceptoComponent implements OnInit {
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: Ctbcon[];

  @ViewChild('titulo') title: ElementRef;

  constructor(private notificationService: NotificationService,
    private router: Router,
    private conceptoService: ConceptoService,
    public loginService: LoginService
  ) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }

  ngOnInit(): void {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
  this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.conceptoService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }

  eliminar(dtoDelete: Ctbcon): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.conceptoService.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire(err.error.mensaje);
        });
      }
    });
  }

  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.title.nativeElement.value = '';
    this.cargarCatalogo();
  }

}
